import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserData } from "../../entry/server/user.ts";
import { userRepo } from "../../repo/user-repo.ts";
import { AppContext } from "../../context/app-context.tsx";
import AdminPageTitle from "../admin-pages/admin-page-title.tsx";
import { Pagination } from "../../lib/api.ts";
import PaginationView from "../../componrnts/pagination.tsx";

const PAGE_LIMIT = 20;

const ROLE_OPTIONS = [
  { label: "ادمین", value: "admin" },
  { label: "کاربر", value: "user" },
];

export default function UsersList() {
  const [users, setUsers] = useState<UserData[]>([]);
  const [pagination, setPagination] = useState<Pagination | null>(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const { setMessage } = useContext(AppContext);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await userRepo.getUsers(page, PAGE_LIMIT, searchQuery || undefined);
        if (!response.status || !response.data) {
          setMessage({ type: "error", message: response.message || "دریافت لیست کاربران ناموفق بود." });
          setUsers([]);
          return;
        }
        setUsers(response.data);
        setPagination(response.pagination ?? null);
      } catch {
        setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [page, searchQuery, setMessage]);

  const onSearchSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setPage(1);
    setSearchQuery(searchInput.trim());
  };

  return (
    <section className="space-y-4">
      <AdminPageTitle title="کاربران" />

      <form onSubmit={onSearchSubmit} className="flex flex-col gap-2 sm:flex-row sm:items-end">
        <label className="flex-1 space-y-2">
          <span className="text-sm text-slate-300">جستجو</span>
          <input
            value={searchInput}
            onChange={(event) => setSearchInput(event.target.value)}
            placeholder="نام کاربری، نام یا نقش..."
            className="w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none transition focus:border-indigo-400"
          />
        </label>
        <button
          type="submit"
          className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
        >
          جستجو
        </button>
      </form>

      {loading ? (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">در حال دریافت لیست کاربران...</div>
      ) : !users.length ? (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">کاربری یافت نشد.</div>
      ) : (
        <>
          <div className="overflow-x-auto rounded-2xl border border-slate-800 bg-slate-900/60">
            <table className="min-w-full divide-y divide-slate-800 text-sm">
              <thead className="bg-slate-900/80">
                <tr>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">شناسه</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">نام کاربری</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">نام</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">نقش</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">عملیات</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-800">
                {users.map((u) => (
                  <tr key={u.id} className="transition hover:bg-slate-900">
                    <td className="whitespace-nowrap px-4 py-3 text-slate-300">{u.id}</td>
                    <td className="px-4 py-3 text-slate-100">{u.username}</td>
                    <td className="px-4 py-3 text-slate-300">{u.name || "—"}</td>
                    <td className="whitespace-nowrap px-4 py-3 text-slate-300">{ROLE_OPTIONS.find((opt) => opt.value === u.role)?.label || "—"}</td>
                    <td className="px-4 py-3">
                      <Link
                        to={`/admin/users/${u.id}`}
                        className="inline-flex rounded-lg border border-indigo-700 px-3 py-1.5 text-xs text-indigo-200 transition hover:border-indigo-500 hover:text-indigo-300"
                      >
                        جزئیات
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {pagination ? <PaginationView pagination={pagination} onPageChange={setPage} /> : null}
        </>
      )}
    </section>
  );
}
